import type { Trip } from "../types/logisticsTypes.ts"

export const getTripHours = (trip: Trip): number | null => {
  if (trip.start && trip.end) {
    const start = new Date(trip.start)
    const end = new Date(trip.end)

    const millis = end.getTime() - start.getTime()

    const hours = millis / (1000 * 60 * 60)

    return hours > 5 ? null : hours
  } else {
    return 0
  }
}
